/* Artful Escape — theme interactions (marquees are pure CSS) */
(function(){
  function initReveal(){
    var els=document.querySelectorAll(".reveal");
    if(!("IntersectionObserver" in window)){els.forEach(function(e){e.classList.add("in")});return;}
    var io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.add("in");io.unobserve(e.target);}})},{threshold:.12,rootMargin:"0px 0px -40px 0px"});
    els.forEach(function(e){io.observe(e)});
  }
  function initHeader(){
    var h=document.querySelector(".site-header");if(!h)return;
    var on=function(){h.classList.toggle("scrolled",window.scrollY>20)};on();
    window.addEventListener("scroll",on,{passive:true});
  }
  function initParallaxMouse(){
    var art=document.querySelector(".hero-art");
    if(!art||matchMedia("(prefers-reduced-motion:reduce)").matches)return;
    var tiles=art.querySelectorAll(".tile");
    window.addEventListener("mousemove",function(e){
      var x=(e.clientX/window.innerWidth-.5),y=(e.clientY/window.innerHeight-.5);
      tiles.forEach(function(t,i){var d=(i+1)*8;t.style.translate=(x*d)+"px "+(y*d)+"px";});
    },{passive:true});
  }
  function initScrollParallax(){
    var els=[].slice.call(document.querySelectorAll("[data-parallax]"));
    if(!els.length||matchMedia("(prefers-reduced-motion:reduce)").matches)return;
    var ticking=false;
    function update(){var vh=window.innerHeight;els.forEach(function(el){var r=el.getBoundingClientRect();var mid=r.top+r.height/2;var off=(mid-vh/2)/vh;el.style.transform="translateY("+(off*(+el.dataset.parallax)*-100)+"px)";});ticking=false;}
    window.addEventListener("scroll",function(){if(!ticking){requestAnimationFrame(update);ticking=true;}},{passive:true});update();
  }
  function initDrawer(){
    var drawer=document.querySelector(".drawer");if(!drawer)return;
    var close=function(){drawer.classList.remove("open");document.documentElement.style.overflow="";};
    // event delegation so it works regardless of render timing / overlaps
    document.addEventListener("click",function(e){
      if(e.target.closest(".burger")){e.preventDefault();drawer.classList.add("open");document.documentElement.style.overflow="hidden";return;}
      if(e.target.closest(".drawer .scrim")||e.target.closest(".d-close")||e.target.closest(".drawer .panel a")){close();}
    });
    document.addEventListener("keydown",function(e){if(e.key==="Escape")close();});
    if(location.hash==="#menu")drawer.classList.add("open");
  }
  function initAccordion(){
    document.querySelectorAll(".acc-head").forEach(function(h){
      h.addEventListener("click",function(){
        var item=h.closest(".acc-item"),body=item.querySelector(".acc-body");
        var isOpen=item.classList.toggle("open");
        body.style.maxHeight=isOpen?body.scrollHeight+"px":0;
      });
    });
  }
  function initQty(){
    document.querySelectorAll(".qty").forEach(function(q){
      var inp=q.querySelector("input");if(!inp)return;
      var set=function(n){inp.value=Math.max(1,n);inp.dispatchEvent(new Event("change",{bubbles:true}));};
      var m=q.querySelector("[data-qminus]"),p=q.querySelector("[data-qplus]");
      if(m)m.addEventListener("click",function(){set(+inp.value-1)});
      if(p)p.addEventListener("click",function(){set(+inp.value+1)});
    });
  }
  function initSort(){
    var ss=document.querySelector("[data-sort]");if(!ss)return;
    ss.addEventListener("change",function(){var u=new URL(location.href);u.searchParams.set("sort_by",ss.value);location.href=u.toString();});
  }
  function initGallery(){
    var main=document.getElementById("ae-main-img");var thumbs=document.querySelectorAll(".g-thumbs button");
    if(!main||!thumbs.length)return;
    thumbs.forEach(function(b){b.addEventListener("click",function(){
      main.src=b.dataset.src; if(main.srcset)main.srcset="";
      thumbs.forEach(function(x){x.classList.remove("active");}); b.classList.add("active");
    });});
  }
  function boot(){initReveal();initHeader();initParallaxMouse();initScrollParallax();initDrawer();initAccordion();initQty();initSort();initGallery();
    document.querySelectorAll("[data-year]").forEach(function(e){e.textContent=(new Date()).getFullYear();});
    if(location.search.indexOf("cap=1")>-1){
      document.querySelectorAll('img[loading="lazy"]').forEach(function(i){i.loading="eager";});
      requestAnimationFrame(function(){document.querySelectorAll(".reveal").forEach(function(e){e.classList.add("in");});});
    }}
  if(document.readyState!=="loading")boot();else document.addEventListener("DOMContentLoaded",boot);
})();
